import styles from "./Partners.module.css";

function PartnerCard({
  link,
  img,
  alt
}) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className={styles.card}
    >
      <img src={img} alt={alt} />
    </a>
  );
}

export default PartnerCard;
